import React from "react";
import type { FC, PropsWithChildren } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, loginSliceValue } from "../redux/reducers/loginSlice";
import { SelectBox } from "./Modal";
import { SideProps } from "../components/SideBar/index";

type HeaderProps = PropsWithChildren<{
  headerTitle?: string;
  addBtn?: boolean;
  addBtnTitle?: string;
  addBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
  addBtnIcon?: string;
  searchBox?: boolean;
  searchPlaceholder?: string;
  handleSearchChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  totalReult?: string;
  userRole: string;
  dropdown?: boolean;
  dropdownValue?: string;
  dropdownChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  dropdownOptions?: { value: string; label: string }[];
  dropdown2?: boolean;
  dropdown2Value?: string;
  dropdown2Change?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  dropdown2Options?: { value: string; label: string }[];
  extraBtn?: boolean;
  extraBtnTitle?: string;
  extraBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
  list?: boolean;
  currentMenu?: SideProps["currentMenu"];
}>;

const Header: FC<HeaderProps> = ({
  headerTitle,
  addBtn = false,
  addBtnTitle = "Add",
  addBtnClick,
  addBtnIcon = "plus-circle",
  searchBox = false,
  searchPlaceholder = "Search here...",
  handleSearchChange,
  totalReult,
  userRole,
  dropdown,
  dropdownValue,
  dropdownChange,
  dropdownOptions,
  dropdown2,
  dropdown2Value,
  dropdown2Change,
  dropdown2Options,
  extraBtn,
  extraBtnTitle,
  extraBtnClick,
  list = false,
  currentMenu,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector(loginSliceValue);
  let loginUserRole = userDetails.data?.user.role;

  const handleFocus = () => {
    const headerTextInput =
      document.querySelector<HTMLElement>(".headerTextInput");
    const headerTextInputIcon = document.querySelector<HTMLElement>(
      ".headerTextInput_icon"
    );
    if (headerTextInput) headerTextInput.style.border = "1px solid var(--grey)";
    if (headerTextInputIcon) headerTextInputIcon.style.fill = "var(--black)";
  };

  const handleFocusOut = () => {
    const headerTextInput =
      document.querySelector<HTMLElement>(".headerTextInput");
    const headerTextInputIcon = document.querySelector<HTMLElement>(
      ".headerTextInput_icon"
    );
    if (headerTextInput)
      headerTextInput.style.border = "1px solid var(--light-grey)";
    if (headerTextInputIcon)
      headerTextInputIcon.style.fill = "var(--light-grey)";
  };

  return (
    <div className="header">
      <div className="header__left">
        {/* <div>
          <h1 className="header__title">{headerTitle}</h1>
          {totalReult && <p className="headerResult">{totalReult}</p>}
        </div> */}

        {addBtn && (
          <button className="header__button" onClick={addBtnClick}>
            {addBtnTitle}
            <svg className="header__button_icon">
              <use xlinkHref={`/assets/sprite.svg#icon-${addBtnIcon}`} />
            </svg>
          </button>
        )}

        {/* added extra button if required */}
        {extraBtn && (
          <button className="header__button" onClick={extraBtnClick}>
            {extraBtnTitle}
            {/* <svg className='header__button_icon'>
              <use xlinkHref={`/assets/sprite.svg#icon-${addBtnIcon}`} />
            </svg> */}
          </button>
        )}
        {searchBox && (
          <div className="headerTextInput">
            <svg className="headerTextInput_icon">
              <use xlinkHref={`/assets/sprite.svg#icon-search`} />
            </svg>
            <input
              type="text"
              className="headerTextBox"
              placeholder={searchPlaceholder}
              onChange={handleSearchChange}
              onFocus={handleFocus}
              onBlur={handleFocusOut}
            />
          </div>
        )}

        {list && loginUserRole == "manager" && (
          <>
            <div className="header-patient">
              <div
                className={`header-patient-card ${
                  currentMenu === "PatientsDashboard" ||
                  currentMenu === "dashboard"
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/patientdashboard">
                  <svg className="navigation__icon">
                    <use
                      xlinkHref={`/assets/sprite.svg#icon-patient-dashboard`}
                    />
                  </svg>
                  <span>Patients Dashboard</span>
                </Link>
              </div>
              <div className="header-patient-card">
                <Link to="/Patient">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-patient-list`} />
                  </svg>
                  <span>Patient List</span>
                </Link>
              </div>
            </div>
          </>
        )}
        {list && loginUserRole == "admin" && (
          <>
            <div className="header-patient">
              {/* <div className={`header-patient-card ${currentMenu === 'PatientsDashboard' ? 'active' : ''}`}>
                <Link to='/patientdashboard'>
                  <svg className='navigation__icon'>
                    <use xlinkHref={`/assets/sprite.svg#icon-patient-dashboard`} />
                  </svg>
                  <span>Patients Dashboard</span>
                </Link>
              </div>
              <div className='header-patient-card'>
                <Link to='/Patient'>
                  <svg className='navigation__icon'>
                    <use xlinkHref={`/assets/sprite.svg#icon-patient-list`} />
                  </svg>
                  <span>Patient List</span>
                </Link>
              </div> */}
              <div
                className={`header-patient-card ${
                  currentMenu === "RTM" ? "active" : ""
                }`}
              >
                <Link to="/rtm-plan">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-plan`} />
                  </svg>
                  <span>Plan</span>
                </Link>
              </div>
              <div
                className={`header-patient-card ${
                  currentMenu === "rtm-template" ? "active" : ""
                }`}
              >
                <Link to="/rtm-template">
                  <svg className="navigation__icon">
                    <use
                      xlinkHref={`/assets/sprite.svg#icon-template-header`}
                    />
                  </svg>
                  <span>Template</span>
                </Link>
              </div>
            </div>
          </>
        )}
        {loginUserRole == "rtmAdmin" && (
          <>
            <div className="header-patient">
              <div
                className={`header-patient-card ${
                  currentMenu === "PatientsDashboard" ||
                  currentMenu === "dashboard"
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/patientdashboard">
                  <svg className="navigation__icon">
                    <use
                      xlinkHref={`/assets/sprite.svg#icon-patient-dashboard`}
                    />
                  </svg>
                  <span>RTM Dashboard</span>
                </Link>
              </div>
              <div
                className={`header-patient-card ${
                  currentMenu === "patient" ? "active" : ""
                }`}
              >
                <Link to="/Patient">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-patient-list`} />
                  </svg>
                  <span>Patient List</span>
                </Link>
              </div>
{/* 
              <div
                className={`header-patient-card ${
                  currentMenu === "BillingList" ? "active" : ""
                }`}
              >
                <Link to="/billing-list">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-billing-list`} />
                  </svg>
                  <span>Billing List</span>
                </Link>
              </div> */}
              {/* <div
                className={`header-patient-card ${
                  currentMenu === "RTM" ? "active" : ""
                }`}
              >
                <Link to="/rtm-plan">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-plan`} />
                  </svg>
                  <span>Plan</span>
                </Link>
              </div>
              <div
                className={`header-patient-card ${
                  currentMenu === "rtm-template" ? "active" : ""
                }`}
              >
                <Link to="/rtm-template">
                  <svg className="navigation__icon">
                    <use
                      xlinkHref={`/assets/sprite.svg#icon-template-header`}
                    />
                  </svg>
                  <span>Template</span>
                </Link>
              </div> */}
            </div>
          </>
        )}

        {loginUserRole == "clinician" && (
          <>
            <div className="header-patient">
              <div
                className={`header-patient-card ${
                  currentMenu === "PatientsDashboard" ||
                  currentMenu === "dashboard"
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/patientdashboard">
                  <svg className="navigation__icon">
                    <use
                      xlinkHref={`/assets/sprite.svg#icon-patient-dashboard`}
                    />
                  </svg>
                  <span>RTM Dashboard</span>
                </Link>
              </div>
              <div
                className={`header-patient-card ${
                  currentMenu === "patient" ? "active" : ""
                }`}
              >
                <Link to="/Patient">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-patient-list`} />
                  </svg>
                  <span>Patient List</span>
                </Link>
              </div>
              {/* <div className={`header-patient-card ${currentMenu === 'RTM' ? 'active' : ''}`}>
                <Link to='/rtm-plan'>
                  <svg className='navigation__icon'>
                    <use xlinkHref={`/assets/sprite.svg#icon-plan`} />
                  </svg>
                  <span>Plan</span>
                </Link>
              </div> */}
              {/* <div
                className={`header-patient-card ${
                  currentMenu === "BillingList" ? "active" : ""
                }`}
              >
                <Link to="/billing-list">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-billing-list`} />
                  </svg>
                  <span>Billing List</span>
                </Link>
              </div> */}
              {/* <div className={`header-patient-card ${currentMenu === 'rtm-template' ? 'active' : ''}`}>
                <Link to='/rtm-template'>
                  <svg className='navigation__icon'>
                    <use xlinkHref={`/assets/sprite.svg#icon-template-header`} />
                  </svg>
                  <span>Template</span>
                </Link>
              </div> */}
            </div>
          </>
        )}

        {loginUserRole == "rtmProvider" && (
          <>
            <div className="header-patient">
              <div className="header-patient-card active">
                <Link to="/Patient">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-patient-list`} />
                  </svg>
                  <span>Patient List</span>
                </Link>
              </div>
            </div>
          </>
        )}

        {loginUserRole == "rtmManager" && (
          <>
            <div className="header-patient">
              <div
                className={`header-patient-card ${
                  currentMenu === "PatientsDashboard" ||
                  currentMenu === "dashboard"
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/patientdashboard">
                  <svg className="navigation__icon">
                    <use
                      xlinkHref={`/assets/sprite.svg#icon-patient-dashboard`}
                    />
                  </svg>
                  <span>RTM Dashboard</span>
                </Link>
              </div>
              <div
                className={`header-patient-card ${
                  currentMenu === "patient" ? "active" : ""
                }`}
              >
                <Link to="/Patient">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-patient-list`} />
                  </svg>
                  <span>Patient List</span>
                </Link>
              </div>
              {/* <div
                className={`header-patient-card ${
                  currentMenu === "BillingList" ? "active" : ""
                }`}
              >
                <Link to="/billing-list">
                  <svg className="navigation__icon">
                    <use xlinkHref={`/assets/sprite.svg#icon-billing-list`} />
                  </svg>
                  <span>Billing List</span>
                </Link>
              </div> */}
            </div>
          </>
        )}

        {dropdown && (
          <SelectBox
            label=""
            value={dropdownValue ? dropdownValue : ""}
            onChange={dropdownChange}
            inputContainerStyle={{
              width: "25rem",
              boxShadow: "unset",
              padding: ".8rem 1rem",
              borderRadius: "1rem",
              border: "1px solid var(--light-grey)",
            }}
          >
            {dropdownOptions &&
              dropdownOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </SelectBox>
        )}

        {dropdown2 && (
          <SelectBox
            label=""
            value={dropdown2Value ? dropdown2Value : ""}
            onChange={dropdown2Change}
            inputContainerStyle={{
              width: "25rem",
              boxShadow: "unset",
              padding: ".8rem 1rem",
              borderRadius: "1rem",
              border: "1px solid var(--light-grey)",
            }}
          >
            {dropdown2Options &&
              dropdown2Options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </SelectBox>
        )}
      </div>
      <div className="header__right">
        <div className="header__user-info">
          <span className="header__welcome">Welcome,</span>
          <Link to="/my-profile" className="header__username">
            {userDetails?.data?.user?.name || "User"}
          </Link>
        </div>
        {userRole === "admin" && (
          <Link to="/app-notifications" className="header__link">
            Notifications
          </Link>
        )}

        {userRole === "admin" && (
          <Link to="/app-version" className="header__link">
            App Version
          </Link>
        )}

        <button
          className="header__logout"
          onClick={() => {
            dispatch(logoutUser());
            navigate("/login");
          }}
        >
          Logout
          <svg className="header__logout_icon">
            <use xlinkHref={`/assets/sprite.svg#icon-sign-out`} />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Header;
